var __jsx = React.createElement;
import React from "react";
import { jsx as ___EmotionJSX } from "@emotion/core";
const HongKong = () => {
  return ___EmotionJSX("svg", {
    fill: "none",
    height: "15",
    viewBox: "0 0 20 15",
    width: "20",
    xmlns: "http://www.w3.org/2000/svg"
  }, ___EmotionJSX("mask", {
    height: "15",
    id: "mask0_305_22390",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    },
    width: "20",
    x: "0",
    y: "0"
  }, ___EmotionJSX("rect", {
    fill: "white",
    height: "15",
    width: "20"
  })), ___EmotionJSX("g", {
    mask: "url(#mask0_305_22390)"
  }, ___EmotionJSX("path", {
    clipRule: "evenodd",
    d: "M0 0V15H20V0H0Z",
    fill: "#EA1A1A",
    fillRule: "evenodd"
  }), ___EmotionJSX("mask", {
    height: "15",
    id: "mask1_305_22390",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    },
    width: "20",
    x: "0",
    y: "0"
  }, ___EmotionJSX("path", {
    clipRule: "evenodd",
    d: "M0 0V15H20V0H0Z",
    fill: "white",
    fillRule: "evenodd"
  })), ___EmotionJSX("g", {
    mask: "url(#mask1_305_22390)"
  }, ___EmotionJSX("g", {
    filter: "url(#filter0_d_305_22390)"
  }, ___EmotionJSX("path", {
    clipRule: "evenodd",
    d: "M9.91845 7.23423C9.91845 7.23423 6.2999 4.00719 10.6179 2.12695C10.6179 2.12695 11.8737 3.51234 10.9316 5.06763C10.6226 5.57773 10.3619 5.94199 10.166 6.21573C9.76464 6.77656 9.63519 6.95745 9.91845 7.23423ZM4.57797 4.91719C4.32945 9.62022 8.83379 7.82629 8.83379 7.82629C8.45974 7.95585 8.3558 7.7592 8.03367 7.1497C7.87637 6.85208 7.66704 6.45602 7.34883 5.95144C6.37887 4.41334 4.57797 4.91719 4.57797 4.91719ZM11.3988 7.39191C11.3988 7.39191 16.0438 8.78248 12.9288 12.3148C12.9288 12.3148 11.2042 11.5915 11.3988 9.78375C11.4627 9.19098 11.5445 8.75071 11.606 8.4198L11.606 8.41979L11.606 8.41979C11.732 7.74154 11.7726 7.52271 11.3988 7.39191ZM10.178 8.47606C10.178 8.47606 11.0107 13.2525 6.45855 12.0454C6.45855 12.0454 6.33462 10.1796 8.03867 9.54552C8.59765 9.33749 9.02812 9.21376 9.35162 9.12078C10.0144 8.93028 10.2281 8.86884 10.178 8.47606ZM15.9242 6.42207C13.077 2.6707 10.7961 6.94905 10.7961 6.94905C10.9982 6.60853 11.2045 6.69156 11.8439 6.94889C12.1563 7.07458 12.5719 7.24186 13.1409 7.42167C14.8746 7.9696 15.9242 6.42207 15.9242 6.42207Z",
    fill: "white",
    fillRule: "evenodd"
  })), ___EmotionJSX("path", {
    d: "M6.35077 6.38C6.35077 6.38 7.26065 7.81198 8.75071 7.81198",
    stroke: "#EA1A1A",
    strokeWidth: "0.625"
  }), ___EmotionJSX("path", {
    d: "M9.91266 4.40637C9.91266 4.40637 9.09611 5.91277 9.79565 7.22841",
    stroke: "#EA1A1A",
    strokeWidth: "0.625"
  }), ___EmotionJSX("path", {
    d: "M13.8187 6.10095C13.8187 6.10095 11.9124 5.81195 10.9153 6.91928",
    stroke: "#EA1A1A",
    strokeWidth: "0.625"
  }), ___EmotionJSX("path", {
    d: "M12.7052 9.59058C12.7052 9.59058 12.3248 7.70033 10.9432 7.14215",
    stroke: "#EA1A1A",
    strokeWidth: "0.625"
  }), ___EmotionJSX("path", {
    d: "M8.70828 10.6167C8.70828 10.6167 10.3544 9.6127 10.4064 8.12355",
    stroke: "#EA1A1A",
    strokeWidth: "0.625"
  }))), ___EmotionJSX("defs", null, ___EmotionJSX("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: "12.1877",
    id: "filter0_d_305_22390",
    width: "13.3561",
    x: "3.56805",
    y: "1.12695"
  }, ___EmotionJSX("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), ___EmotionJSX("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), ___EmotionJSX("feOffset", null), ___EmotionJSX("feGaussianBlur", {
    stdDeviation: "0.5"
  }), ___EmotionJSX("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6 0 0 0 0 0 0 0 0 0 0 0 0 0 0.36 0"
  }), ___EmotionJSX("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_305_22390"
  }), ___EmotionJSX("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_305_22390",
    mode: "normal",
    result: "shape"
  }))));
};
export default HongKong;
//# sourceMappingURL=HongKong.js.map
// @zapier/checkout@7.13.0 (cd15c152f)
